import { combineReducers } from "redux";
import {
  AddCADMarkerReducers,
  AddColorPrefixReducers,
  AddColorSuffixReducers,
  AddCostGroupReducers,
  AddCostPriceSettingReducers,
  AddRemarkReducers,
  AddStylePrefixReducers,
  AddStyleSuffixReducers,
  ApproveRejectCostPriceReducers,
  CostingSummaryDropdownReducers,
  CreateMasterGroupDataReducers,
  CreateSessionReducers,
  DropdownDataReducers,
  ExportTemplateReducers,
  GetColorPrefixReducers,
  GetColorSuffixReducers,
  GetConsumptionPricePriceHistoryReducers,
  GetCostGroupArrayReducers,
  getCostGroupSummaryReducers,
  getCostPriceChangeLogReducers,
  getCostPriceSettingReducers,
  getDropdownDataListMasterGroupReducers,
  getListingQualityRatingReducers,
  getMasterGroupDataReducers,
  GetMasterGroupProductListReducers,
  GetPhotoshootDataReducers,
  getPortalListSummaryHistoryReducers,
  getportalListSummaryOldSkuListReducers,
  getPriceBandSummaryReducers,
  getPriceComponentForApproveRejectReducers,
  GetPriceComponentReducers,
  getProductGroupDetailsReducers,
  GetProductSubGroupSummaryReducers,
  GetRemarkReducers,
  getSessionReducers,
  getSiteCodeInventoryReducers,
  getSizesReducers,
  GetStylePrefixReducers,
  GetStyleSuffixReducers,
  PrepareForExportReducers,
  PrepareForExportStepReducers,
  SavePriceBandReducers,
  SubmitDirectImportReducers,
  UpdateCostPriceDetailsReducers,
  UpdateForExportStepReducers,
  ViewCADMarkerReducers,
} from "../Reducers/PortalList.Reducers";

const rootReducer = combineReducers({
  DropdownData: DropdownDataReducers,
  DirectImport: SubmitDirectImportReducers,
  ExportData: PrepareForExportReducers,
  ExportDataStep: PrepareForExportStepReducers,
  style_prefix: GetStylePrefixReducers,
  style_suffix: GetStyleSuffixReducers,
  color_prefix: GetColorPrefixReducers,
  color_suffix: GetColorSuffixReducers,
  AddStylePrefix: AddStylePrefixReducers,
  AddStyleSuffix: AddStyleSuffixReducers,
  AddColorSuffix: AddColorSuffixReducers,
  AddColorPrefix: AddColorPrefixReducers,
  PhotoShoot: GetPhotoshootDataReducers,
  ExportTemplate: ExportTemplateReducers,
  CreateSession: CreateSessionReducers,
  Session: getSessionReducers,
  UpdateExport: UpdateForExportStepReducers,
  PortalListingSummary: getportalListSummaryOldSkuListReducers,
  PortalSummaryHistory: getPortalListSummaryHistoryReducers,
  ListingQuality: getListingQualityRatingReducers,
  SiteCodeInventoy: getSiteCodeInventoryReducers,
  AddCostPriceSetting: AddCostPriceSettingReducers,
  costPriceSetting: getCostPriceSettingReducers,
  size: getSizesReducers,
  costGroupSummary: getCostGroupSummaryReducers,
  SaveCost: AddCostGroupReducers,
  PriceBandSummary: getPriceBandSummaryReducers,
  SavePriceBand: SavePriceBandReducers,
  portalListSubGroupSummary: GetProductSubGroupSummaryReducers,
  SaveCADMarker: AddCADMarkerReducers,
  PriceComponent: GetPriceComponentReducers,
  costGroupSize: GetCostGroupArrayReducers,
  updateCostPriceComponent: UpdateCostPriceDetailsReducers,
  ProductStyleColor: CostingSummaryDropdownReducers,
  ProductGroupDetails: getProductGroupDetailsReducers,
  CostPricechangeLog: getCostPriceChangeLogReducers,
  PriceComponentApprovedRejected: getPriceComponentForApproveRejectReducers,
  MasterGroupList: getMasterGroupDataReducers,
  dropdownDataListMasterGroup: getDropdownDataListMasterGroupReducers,
  createMasterGroupData: CreateMasterGroupDataReducers,
  MasterProductGroupList: GetMasterGroupProductListReducers,
  RemarkCreation: AddRemarkReducers,
  ViewCADMarker: ViewCADMarkerReducers,
  Remarks: GetRemarkReducers,
  ApproveRejectCostPrice: ApproveRejectCostPriceReducers,
  consumptionPriceHistory: GetConsumptionPricePriceHistoryReducers,
});

export default rootReducer;
